import { Link, useNavigate } from 'react-router-dom';

import { zodResolver } from '@hookform/resolvers/zod';
import { SubmitHandler, useForm } from 'react-hook-form';

import InputFloating from '@/components/atoms/InputFloating';
import { z } from 'zod';
import { Button } from '@/components/ui/button';

import useSignIn from '@/lib/useQuery/user/useSignIn';
import { useState } from 'react';
import { Label } from '@/components/ui/label';
import LoaderWithBackdrop from '@/components/custom/LoaderWithBackdrop';
import PageWrapper from '@/components/atoms/PageWrapper';
import { NavigationBarBreadCrumbs } from '@/components/molecules/BackNav';


export default function Login() {
  const schema = z.object({
    email: z.string().email(),
    password: z.string().min(1, "Password is required"),
  });
  const navigate = useNavigate();
  const { mutateAsync: mutateSignIn, isPending } = useSignIn(() => {
    navigate('/welcome')
  });

  type Inputs = z.infer<typeof schema>;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({
    resolver: zodResolver(schema),
  })

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    mutateSignIn(data)
  };
  const [showPassword, setShowPassword] = useState(false);
  return (
    <PageWrapper className='flex flex-col items-center flex-1 w-full max-w-full custom_bg'>
      {isPending && <LoaderWithBackdrop />}
      <NavigationBarBreadCrumbs.Set
        currentPageName='Login'
        pages={[]}
      />
      <div className="max-w-[1200px] flex flex-col md:flex-row items-stretch gap-4 align-center justify-center">

        <div className="flex flex-col max-w-xl gap-3 px-3 py-8 rounded-lg grow sm:px-8 md:w-2/5 bg-gray-50/80">
          <p className="text-lg" >
            Welcome to the Collaborate Platform, designed by the MeasuringTogether Team! This platform aims to create bi-directional conversations around data in lieu of traditional surveying.
          </p>
          <p className="text-lg">
            We hope that you will use this tool to engage with your teams and create conversations that will improve both data accuracy and the ability for everyone to participate in data storytelling.
          </p>
          <p className="text-lg" >
            If you have any questions, reach out to our team at
            <a className='text-primary underline-offset-4 hover:underline' href="mailto: billy@srcdevhub.com">&nbsp;billy@srcdevhub.com</a>
          </p>
        </div>

        <div className="justify-center max-w-xl px-3 py-8 rounded grow sm:px-8 bg-gray-50/80">
          <div className="mb-4">
            <h1 className="font-bold text-center">Login</h1>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <InputFloating
              showError
              type="text"
              label="E-mail"
              register={register("email", { required: true })}
              errorMessage={errors.email?.message}
            />
            <div className="">
              <Label>Password</Label>
              <div className="relative">
                <InputFloating
                  showError
                  type={showPassword ? "text" : "password"}
                  register={register("password", { required: true })}
                  errorMessage={errors.password?.message}
                />
                <button
                  type="button"
                  className="absolute justify-center transform translate-y-1/2 bottom-1/2 right-2"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`text-xl bi bi-eye${showPassword ? "-slash" : ""}`}></i>
                </button>
              </div>
            </div>
            <div className="p-0 m-0 text-end " >
              <Link to={'/forgot-password'} className="text-blue-700">
                Forgot your password?
              </Link>
            </div>
            <Button
              type="submit"
              className="w-full"
            >
              Sign In
            </Button>
          </form>
          <div className="mt-2 text-center">
            Don't have an account? <br />
            <Link to="/register" className="">
              Register <span className="text-blue-700">here</span>
            </Link>
          </div>
        </div>

      </div>
    </PageWrapper>
  );
}

